module.exports = __webpack_public_path__ + "31f3812b05756e0f4c635359e2d44637.svg";